import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appDragDrop]'
})
export class DragDropDirective {
    @Output() files: EventEmitter<FileList> = new EventEmitter();
    @Input() hoverClass = 'active';

    constructor(private renderer: Renderer2, private element: ElementRef) {
    }

    @HostListener('dragenter', ['$event'])
    public onDragEnter(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.hoverClass)
            this.renderer.addClass(this.element.nativeElement, this.hoverClass)
    }

    @HostListener('dragover', ['$event'])
    public onDragOver(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
    }

    @HostListener('dragleave', ['$event'])
    public onDragLeave(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.hoverClass)
            this.renderer.removeClass(this.element.nativeElement, this.hoverClass)
    }

    @HostListener('drop', ['$event'])
    public onDrop(evt: DragEvent) {
        evt.preventDefault();
        evt.stopPropagation();

        if (evt.dataTransfer && evt.dataTransfer.files.length > 0) {
            this.files.emit(evt.dataTransfer.files);
        }
    }
}
